import React, { FunctionComponent } from "react";
import { Link } from "gatsby";

export interface Wordmark {
  size: "masthead" | "compact";
  className?: string;
}

const SIZES = {
  masthead: "text-wordmark-sm md:text-wordmark-md lg:text-wordmark",
  compact: "text-wordmark-compact",
};

export const Wordmark: FunctionComponent<Wordmark> = ({
  size,
  className = "",
}) => (
  <Link
    to="/"
    aria-label="taibo.ca home"
    className={`font-display font-extrabold text-current ${SIZES[size]} ${className}`}
  >
    taibo<span className="wordmark-dot">.</span>
  </Link>
);
